module.exports = __webpack_public_path__ + "static/media/SF-5-A.2f49eca2.mp3";